export default ['gender.male', 'gender.female', 'gender.diverse'];
